/** @jsx h */
import { h } from 'preact'
import Dial from './dial'

const digitsRe = /\d/

export default ({
  children,
  className,
  height = 40,
  fontSize,
  numberSpacing = 0,
  keyBase = ''
}) => {
  let characters = (children[0] + '').split('')
  let numbers = characters.filter(char => digitsRe.test(char))
  const number = numbers.join('')
  let numberCount = 0
  let charCount = 0

  return (
    <div className={className || null}>
      <div
        className='flex items-end'
        style={{
          position: 'relative',
          overflowY: 'hidden',
          height: height + 'px'
        }}
      >
        {characters.map((char, index) => {
          const isNumber = digitsRe.test(char)
          let numberIndex
          let charIndex
          if (isNumber) {
            numberIndex = numberCount++
          } else {
            charIndex = charCount++
          }

          const key = isNumber
            ? `${keyBase}numCont${numbers.length - numberIndex}`
            : `${keyBase}charCont${charIndex}`

          return (
            <Dial
              height={height}
              fontSize={fontSize}
              numberSpacing={numberSpacing}
              key={key}
              char={char}
              numberIndex={numberIndex}
              number={number}
            />
          )
        })}
      </div>
    </div>
  )
}
